import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 14v-6h-6","key":"svg-0"}],["path",{"d":"M21 8l-9 9l-9 -9","key":"svg-1"}]]

/**
 * IconArrowElbowRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctZWxib3ctcmlnaHQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTIxIDE0di02aC02IiAvPgogIDxwYXRoIGQ9Ik0yMSA4bC05IDlsLTkgLTkiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-elbow-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowElbowRight = createReactComponent('outline', 'arrow-elbow-right', 'ArrowElbowRight', __iconNode);

export default IconArrowElbowRight;